module.exports = require('buffer')



//////////////////
// WEBPACK FOOTER
// ./~/safe-buffer/browser.js
// module id = 166
// module chunks = 0 2